import { clientApi } from "@/shared/services/apiClient"

import type {
  KayitDogrulaBasarili,
  KayitDogrulaRequest,
  KayitDurumResponse,
  KayitHatasi,
  KayitTalebiBasarili,
  KayitTalebiRequest,
} from "../types/kayit-types"

/**
 * §1 — üç uç da public: proxy `PUBLIC_ENDPOINTS` içindeki `/tenant/kayit`
 * öneki sayesinde ne `Authorization` ne `X-Tenant-Code` basılır. Servis de
 * bilerek `headers` göndermez.
 *
 * Sözleşmeli hatalar (400/403/429) axios seviyesinde KABUL edilir: global
 * interceptor bu gövdelerden okunur mesaj çıkaramıyor ("Lütfen girdiğiniz
 * bilgileri kontrol edin") ve public rotada `<Toaster />` zaten mount edilmemiş.
 * Ekran `kalan_deneme` gibi alanları satır içinde işler.
 */
const KAYIT_SOZLESMESI = {
  validateStatus: (status: number) =>
    (status >= 200 && status < 300) ||
    status === 400 ||
    status === 403 ||
    status === 404 ||
    status === 429,
}

/**
 * Yollar **sondaki slash olmadan** yazılır: Next `/api/proxy/...` isteğini
 * `trailingSlash: false` ile 308'liyor ve her çağrı fazladan bir tur atıyordu.
 * Backend'e giden slash'ı proxy'nin kendisi ekler.
 */
const KAYIT_DURUM_SOZLESMESI = {
  // Silinmiş/olmayan talep DRF 404 döner; polling'i sonsuz döngüye sokmamak için
  // hata değil, "talep artık yok" sinyali olarak okunur.
  validateStatus: (status: number) => (status >= 200 && status < 300) || status === 404,
}

export type KayitSonuc<T> =
  | { ok: true; data: T }
  | { ok: false; status: number; hata: KayitHatasi }

function sonuclandir<T>(response: {
  status: number
  data: unknown
}): KayitSonuc<T> {
  if (response.status >= 200 && response.status < 300) {
    return { ok: true, data: response.data as T }
  }
  return {
    ok: false,
    status: response.status,
    hata: (response.data ?? {}) as KayitHatasi,
  }
}

export async function kayitTalebiOlustur(
  data: KayitTalebiRequest,
): Promise<KayitSonuc<KayitTalebiBasarili>> {
  const response = await clientApi.post<KayitTalebiBasarili>(
    "/tenant/kayit",
    data,
    KAYIT_SOZLESMESI,
  )
  return sonuclandir<KayitTalebiBasarili>(response)
}

export async function kayitDogrula(
  data: KayitDogrulaRequest,
): Promise<KayitSonuc<KayitDogrulaBasarili>> {
  const response = await clientApi.post<KayitDogrulaBasarili>(
    "/tenant/kayit/dogrula",
    data,
    KAYIT_SOZLESMESI,
  )
  return sonuclandir<KayitDogrulaBasarili>(response)
}

/** Talep bulunamazsa (404) `null` döner — çağıran akışı sonlandırır. */
export async function kayitDurumu(
  talepId: number,
): Promise<KayitDurumResponse | null> {
  const response = await clientApi.get<KayitDurumResponse>(
    `/tenant/kayit/durum/${talepId}`,
    KAYIT_DURUM_SOZLESMESI,
  )
  return response.status === 404 ? null : response.data
}
